/* vstore.js — V Store (adidas-modeled). Vanilla JS, sem jQuery. */

(function () {

  "use strict";

  const $ = (s, r = document) => r.querySelector(s);

  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Locale fixo en-US: com o locale do navegador (pt-BR) o Intl imprimia "US$ 5,00".

  // A loja e em ingles/USD, entao o formato correto e "$5.00".

  const money = (c) => {

    try { return (c / 100).toLocaleString("en-US", { style: "currency", currency: window.Shopify?.currency?.active || "USD" }); }

    catch { return "$" + (c / 100).toFixed(2); }

  };



  /* ---- Mobile menu drawer (adidas-style) ---------------------------------- */

  const header = $(".vs-header");

  const mmenu = $("[data-mmenu]");

  const openMenu = () => { mmenu?.classList.add("is-open"); mmenu?.setAttribute("aria-hidden", "false"); document.body.classList.add("vs-mmenu-open"); };

  const closeMenu = () => { mmenu?.classList.remove("is-open"); mmenu?.setAttribute("aria-hidden", "true"); document.body.classList.remove("vs-mmenu-open"); };

  $("[data-mmenu-open]")?.addEventListener("click", openMenu);

  $$("[data-mmenu-close]").forEach((el) => el.addEventListener("click", closeMenu));

  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeMenu(); });

  // Mobile menu accordion submenus

  $$("[data-mmenu-toggle]").forEach((btn) => btn.addEventListener("click", () => {

    const group = btn.closest(".vs-mmenu__group");

    if (!group) return;

    const open = group.classList.toggle("is-open");

    btn.setAttribute("aria-expanded", open ? "true" : "false");

  }));



  /* ---- Hero video controls (Nike-style) ----------------------------------- */

  $$("[data-hero]").forEach((hero) => {

    const video = $(".vs-hero__video", hero);

    if (!video) return;

    const pp = $("[data-hero-playpause]", hero);

    const mute = $("[data-hero-mute]", hero);

    const show = (btn, sel, on) => { const e = $(sel, btn); if (e) e.hidden = !on; };

    pp?.addEventListener("click", () => {

      if (video.paused) { video.play(); pp.setAttribute("aria-label", "Pause video"); show(pp, ".vs-hero__ic-pause", true); show(pp, ".vs-hero__ic-play", false); }

      else { video.pause(); pp.setAttribute("aria-label", "Play video"); show(pp, ".vs-hero__ic-pause", false); show(pp, ".vs-hero__ic-play", true); }

    });

    mute?.addEventListener("click", () => {

      video.muted = !video.muted;

      mute.setAttribute("aria-label", video.muted ? "Unmute video" : "Mute video");

      show(mute, ".vs-hero__ic-soundoff", video.muted);

      show(mute, ".vs-hero__ic-soundon", !video.muted);

    });

    // "Watch" button: open the video in a fullscreen lightbox (no hero text in front)

    $("[data-hero-watch]", hero)?.addEventListener("click", () => {

      const srcs = $$("source", video).map((s) => ({ src: s.src, type: s.type }));

      const single = video.currentSrc || video.src;

      if (!srcs.length && !single) return;

      video.pause();

      const lb = document.createElement("div");

      lb.className = "vs-videolb";

      const close = document.createElement("button");

      close.className = "vs-videolb__close";

      close.setAttribute("aria-label", "Close");

      close.innerHTML = "&times;";

      const lv = document.createElement("video");

      lv.className = "vs-videolb__video";

      lv.setAttribute("playsinline", "");

      lv.controls = true; lv.autoplay = true;

      if (srcs.length) srcs.forEach((s) => { const el = document.createElement("source"); el.src = s.src; if (s.type) el.type = s.type; lv.appendChild(el); });

      else lv.src = single;

      lb.appendChild(close); lb.appendChild(lv);

      document.body.appendChild(lb);

      document.body.classList.add("vs-mmenu-open");

      requestAnimationFrame(() => lb.classList.add("is-open"));

      lv.play?.().catch(() => {});

      const shut = () => { lv.pause(); lb.remove(); document.body.classList.remove("vs-mmenu-open"); video.play?.().catch(() => {}); };

      close.addEventListener("click", shut);

      lb.addEventListener("click", (e) => { if (e.target === lb) shut(); });

      document.addEventListener("keydown", function esc(e) { if (e.key === "Escape") { shut(); document.removeEventListener("keydown", esc); } });

    });

    // pause when scrolled out of view to save battery

    if ("IntersectionObserver" in window) {

      new IntersectionObserver((ents) => ents.forEach((en) => {

        if (en.isIntersecting) { if (!pp || $(".vs-hero__ic-play", pp)?.hidden !== false) video.play?.().catch(() => {}); }

        else video.pause?.();

      }), { threshold: 0.2 }).observe(hero);

    }

  });



  /* ---- Cart drawer -------------------------------------------------------- */

  const drawer = $("#vsCartDrawer");

  const overlay = $("#vsOverlay");

  function openDrawer() { drawer?.classList.add("is-open"); overlay?.classList.add("is-open"); document.body.style.overflow = "hidden"; }

  function closeDrawer() { drawer?.classList.remove("is-open"); overlay?.classList.remove("is-open"); document.body.style.overflow = ""; }

  overlay?.addEventListener("click", closeDrawer);

  $$("[data-cart-close]").forEach((b) => b.addEventListener("click", closeDrawer));

  $$("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openDrawer(); renderCart(); }));

  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });



  const FREE_SHIP_THRESHOLD = Number(drawer?.dataset.freeship || 0);



  async function getCart() { const r = await fetch("/cart.js", { headers: { Accept: "application/json" } }); return r.json(); }



  function renderCart() {

    const body = $("#vsCartBody"), foot = $("#vsCartFoot"), countEls = $$(".vs-cart-count");

    if (!body) return;

    getCart().then((cart) => {

      pintaContagem(cart);

      if (!cart.item_count) { body.innerHTML = '<p class="vs-empty">Your bag is empty.</p>'; if (foot) foot.innerHTML = ""; return; }

      body.innerHTML = cart.items.map((it) => `

        <div class="vs-cartline" data-key="${it.key}">

          <div class="vs-cartline__media"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2") : ""}" alt="" width="60" height="60"></div>

          <div class="vs-cartline__info">

            <div class="vs-card__title">${it.product_title}</div>

            <div class="vs-card__subtitle">${it.variant_title && it.variant_title !== "Default Title" ? "Size " + it.variant_title : ""}</div>

            ${it.properties ? Object.keys(it.properties).filter((k) => k[0] !== "_" && it.properties[k]).map((k) => `<div class="vs-cartline__prop"><span>${k}:</span> ${it.properties[k]}</div>`).join("") : ""}

            <div class="vs-cartline__row">

              <div class="vs-qty">

                <button data-qty="dec" aria-label="Decrease">–</button><span>${it.quantity}</span><button data-qty="inc" aria-label="Increase">+</button>

              </div>

              <span class="vs-price">${money(it.final_line_price)}</span>

            </div>

            <button class="vs-cartline__rm" data-qty="rm">Remove</button>

          </div>

        </div>`).join("");

      let ship = "";

      if (FREE_SHIP_THRESHOLD > 0) {

        const pct = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);

        const remaining = FREE_SHIP_THRESHOLD - cart.total_price;

        ship = `<div class="vs-shipmsg vs-eyebrow">${remaining > 0 ? "Add " + money(remaining) + " for FREE Express shipping" : "You unlocked FREE Express shipping"}</div><div class="vs-shipbar"><div class="vs-shipbar__fill" style="width:${pct}%"></div></div>`;

      }

      if (foot) foot.innerHTML = `${ship}

        <div class="vs-cartline__row" style="margin:12px 0"><span class="vs-eyebrow">Subtotal</span><span class="vs-price">${money(cart.total_price)}</span></div>

        <a href="/checkout" class="vs-btn vs-btn--block vs-btn--lg">Checkout</a>`;



      body.querySelectorAll(".vs-cartline").forEach((line) => {

        const key = line.dataset.key;

        line.querySelectorAll("[data-qty]").forEach((btn) => btn.addEventListener("click", () => {

          const cur = Number(line.querySelector(".vs-qty span").textContent);

          const action = btn.dataset.qty;

          const q = action === "rm" ? 0 : action === "inc" ? cur + 1 : Math.max(0, cur - 1);

          changeCart(key, q);

        }));

      });

    });

  }

  function changeCart(id, quantity) {

    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id, quantity }) }).then(renderCart);

  }



  /* ---- Painel "Added to Bag" (estilo Nike) -------------------------------

     Em vez de abrir uma gaveta por cima da pagina, desce um painel curto no

     canto: confirma o que entrou e oferece os dois caminhos (ver sacola /

     finalizar) sem tirar o cliente de onde ele estava.                        */

  const elAdd = $("[data-added]");

  let addTimer = null;

  function fechaAdicionado() {

    if (!elAdd) return;

    elAdd.classList.remove("is-open");

    clearTimeout(addTimer);

    setTimeout(() => { elAdd.hidden = true; }, 240);

  }

  $$("[data-added-close]").forEach((b) => b.addEventListener("click", fechaAdicionado));

  // Recebe o item devolvido pelo /cart/add.js. Antes eu pegava "o ultimo item

  // nao-patch do carrinho", mas o /cart.js devolve na ordem de INSERCAO ORIGINAL —

  // reordenar quantidade nao move a linha —, entao o painel mostrava o produto

  // errado (e preco zerado) quando ja havia coisa na sacola.

  function mostraAdicionado(item) {

    if (!elAdd || !item) return;

    const extras = [];

    if (item.variant_title && item.variant_title !== "Default Title") extras.push(String(item.variant_title).split(" / ")[0]);

    const props = item.properties || {};

    if (props.Name || props.Number) extras.push([props.Name, props.Number].filter(Boolean).join(" "));

    const corpo = $("[data-added-body]", elAdd);

    const preco = item.final_line_price != null ? item.final_line_price : (item.final_price || item.price || 0);

    if (corpo) corpo.innerHTML = `

      <img class="vs-added__img" src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2") : ""}" alt="" width="72" height="72">

      <div class="vs-added__txt">

        <div class="vs-added__name">${item.product_title || item.title || ""}</div>

        ${extras.length ? `<div class="vs-added__meta">${extras.join(" · ")}</div>` : ""}

        <div class="vs-added__price">${money(preco)}</div>

      </div>`;

    elAdd.hidden = false;

    requestAnimationFrame(() => elAdd.classList.add("is-open"));

    clearTimeout(addTimer);

    addTimer = setTimeout(fechaAdicionado, 7000);

    elAdd.addEventListener("mouseenter", () => clearTimeout(addTimer), { once: true });

    // contagem do header e do botao "View Bag"

    fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json()).then((cart) => {

      const n = pintaContagem(cart);

      const cnt = $("[data-added-count]", elAdd);

      if (cnt) cnt.textContent = n;

    });

  }



  /* Contagem de itens da sacola SEM os patches: o patch e acessorio de uma

     camisa, nao um item. A pagina /cart ja contava assim; o badge do header e o

     "View Bag (n)" contavam com patch, entao o cliente via 2 no header e 1 no

     carrinho (auditoria 2026-08-09). */

  function contaItens(cart) {

    return (cart.items || []).reduce((n, it) =>

      n + ((it.properties && it.properties._for) ? 0 : it.quantity), 0);

  }

  function pintaContagem(cart) {

    const n = contaItens(cart);

    $$(".vs-cart-count").forEach((el) => { el.textContent = n; el.hidden = n === 0; });

    return n;

  }



  /* ---- Add to cart -------------------------------------------------------- */

  document.addEventListener("submit", (e) => {

    const form = e.target.closest("form[action*='/cart/add']");

    if (!form) return;

    e.preventDefault();

    const btn = form.querySelector("[type=submit]");

    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; }

    var _vsPatchRoot = form.querySelector("[data-patches]"); var _vsChecks = _vsPatchRoot ? _vsPatchRoot.querySelectorAll("[data-patch-check]:checked") : []; var _vsUid = _vsChecks.length ? ("vsp" + Date.now().toString(36) + Math.random().toString(36).slice(2,7)) : ""; var _vsFd = new FormData(form); if (_vsUid) _vsFd.append("properties[_uid]", _vsUid); fetch("/cart/add.js", { method: "POST", body: _vsFd, headers: { Accept: "application/json" } })

      .then((r) => r.json())

      .then(async (adicionado) => {

        const patchRoot = form.querySelector("[data-patches]");

        const checks = patchRoot ? patchRoot.querySelectorAll("[data-patch-check]:checked") : [];

        if (checks.length) {

          const qty = Number(form.querySelector("[name=quantity]") && form.querySelector("[name=quantity]").value) || 1;

          const forKey = _vsUid || (patchRoot.dataset.productTitle || "");

          for (const c of checks) {

            const lbl = c.closest(".vs-patch");

            try {

              await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },

                body: JSON.stringify({ id: Number(lbl.dataset.patchId), quantity: qty, properties: { Patch: lbl.dataset.patchName, Placement: lbl.dataset.patchWhere || "Sleeve", _for: forKey } }) });

            } catch (e) {}

          }

        }

        if (document.getElementById("vsCart")) document.dispatchEvent(new CustomEvent("vs:added"));
        else mostraAdicionado(adicionado);

      })

      .catch(() => alert("Could not add to cart"))

      .finally(() => { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || "Add to bag"; } });

  });



  /* ---- Variant selector (PDP) --------------------------------------------

     Cada opcao (Size, CUSTOMIZE?...) e um grupo proprio. A variante sai da

     combinacao escolhida. Os campos de nome/numero so aparecem quando a

     opcao de personalizacao esta em "Customize".                            */

  $$("[data-product-form]").forEach((root) => {

    const groups = $$("[data-opt-group]", root);

    if (!groups.length) return;

    const mapEl = $("[data-variant-map]", root);

    let variants = [];

    try { variants = JSON.parse(mapEl?.textContent || "[]"); } catch (e) { variants = []; }



    const idInput = $("input[name=id]", root);

    const atc = $("[data-atc]", root);

    const custom = $("[data-custom]", root);

    const elNow = $("[data-price-now]", root);

    const elWas = $("[data-price-was]", root);

    const elSave = $("[data-price-save]", root);



    const selection = () => groups.map((g) => {

      const on = $("[data-opt-value][aria-pressed=true]", g);

      return on ? on.dataset.value : null;

    });



    const findVariant = (sel) => variants.find((v) =>

      v.opts.every((o, i) => sel[i] == null || String(o) === String(sel[i])) &&

      sel.every((s) => s !== null)

    );



    const isCustomOn = () => groups.some((g) => {

      if (!g.hasAttribute("data-opt-custom")) return false;

      const on = $("[data-opt-value][aria-pressed=true]", g);

      return on && /^(?!.*don).*customiz/i.test(on.dataset.value || "");

    });



    const sync = () => {

      const sel = selection();

      const v = findVariant(sel);

      if (v && idInput) idInput.value = v.id;

      // widget de parcelas do Shop Pay acompanha a variante (Customize +$5, 3XL...)

      if (v) { var _pt = document.querySelector("shopify-payment-terms"); if (_pt) _pt.setAttribute("variant-id", v.id); }



      // preco acompanha a variante (3XL/4XL e Customize custam mais)

      if (v && elNow) {

        elNow.textContent = money(v.price);

        const temDesconto = v.compare > v.price;

        if (elWas) {

          elWas.hidden = !temDesconto;

          if (temDesconto) elWas.textContent = money(v.compare);

        }

        if (elSave) {

          elSave.hidden = !temDesconto;

          if (temDesconto) elSave.textContent = "-" + Math.round(((v.compare - v.price) / v.compare) * 100) + "%";

        }

      }

      if (atc) {

        const faltando = sel.some((s) => s === null);

        atc.disabled = faltando || (v && !v.available);

        atc.textContent = faltando ? "Select an option" : (v && !v.available ? "Sold out" : "Add to bag");

      }

      // personalizacao: revela e limpa quando desligada

      const on = isCustomOn();

      if (custom) {

        custom.hidden = !on;

        if (!on) $$("[data-custom-input]", custom).forEach((i) => { i.value = ""; });

      }

      // patches NAO dependem do customize: quem controla e o proprio bloco de patches

    };



    groups.forEach((g) => {

      $$("[data-opt-value]", g).forEach((btn) => btn.addEventListener("click", () => {

        $$("[data-opt-value]", g).forEach((b) => { b.setAttribute("aria-pressed", "false"); b.classList.remove("is-selected"); });

        btn.setAttribute("aria-pressed", "true");

        btn.classList.add("is-selected");

        const lbl = $("[data-opt-label]", g);

        // usa o texto visivel do botao: o valor cru ("Don't Customize") fica so no data-value

        if (lbl) lbl.textContent = btn.dataset.label || btn.textContent.trim();

        sync();

      }));

    });

    sync();

  });



  /* ---- PDP quantity box --------------------------------------------------- */

  $$(".vs-qtybox").forEach((box) => {

    const inp = $("[data-qty-input]", box);

    box.querySelectorAll("[data-qty]").forEach((b) => b.addEventListener("click", () => {

      let v = parseInt(inp.value, 10) || 1;

      v = b.dataset.qty === "inc" ? v + 1 : Math.max(1, v - 1);

      inp.value = v;

    }));

  });



  /* ---- Tabs (shop by league) --------------------------------------------- */

  $$("[data-tabs]").forEach((root) => {

    const tabs = $$(".vs-tab", root);

    const panels = $$(".vs-tab-panel", root);

    const viewAll = $("[data-tab-viewall]", root);

    tabs.forEach((tab) => tab.addEventListener("click", () => {

      const i = tab.dataset.tab;

      tabs.forEach((t) => { t.classList.toggle("is-active", t === tab); t.setAttribute("aria-selected", t === tab); });

      panels.forEach((p) => { const on = p.dataset.panel === i; p.classList.toggle("is-active", on); p.hidden = !on; });

      if (viewAll && tab.dataset.tabUrl) { viewAll.href = tab.dataset.tabUrl; viewAll.textContent = tab.textContent.trim(); }

    }));

  });



  /* ---- Wishlist (localStorage, visual) ----------------------------------- */

  const WKEY = "vs_wishlist";

  /* Guarda HANDLE. Listas antigas gravavam id numerico, que nao serve para

     /products/<handle>.js — sao descartadas aqui, senao a pagina da wishlist

     ficaria vazia para sempre sem dizer por que. */

  const wish = () => {

    try {

      const v = JSON.parse(localStorage.getItem(WKEY) || "[]");

      return Array.isArray(v) ? v.filter((x) => typeof x === "string" && /[a-z]/.test(x)) : [];

    } catch { return []; }

  };

  function paintWish() {

    const w = wish();

    $$("[data-wish]").forEach((b) => b.setAttribute("aria-pressed", w.includes(b.dataset.wish) ? "true" : "false"));

    $$("[data-wish-count-badge]").forEach((el) => { el.textContent = w.length; el.hidden = w.length === 0; });

  }

  document.addEventListener("click", (e) => {

    const b = e.target.closest("[data-wish]"); if (!b) return;

    e.preventDefault();

    const h = b.dataset.wish; let w = wish();

    w = w.includes(h) ? w.filter((x) => x !== h) : [...w, h];

    localStorage.setItem(WKEY, JSON.stringify(w)); paintWish();

  });

  /* a pagina da wishlist avisa quando remove um item, pro badge acompanhar */

  document.addEventListener("vs:wishlist", paintWish);

  paintWish();



  /* ---- Jersey customizer (name & number + choose a player) ---------------- */

  // Os elencos vem da secao "Elencos" (#VsSquadsData), editavel no editor de

  // temas. Escolher um jogador so PREENCHE os campos de nome/numero — o carrinho

  // continua recebendo Name/Number, entao nada muda na producao do pedido.

  function vsSquads() {

    const el = document.getElementById("VsSquadsData");

    if (!el) return [];

    try { return JSON.parse(el.textContent || el.innerHTML) || []; } catch (e) { return []; }

  }

  function vsSquadDoProduto(titulo) {

    const t = (titulo || "").toLowerCase();

    // primeira regra que casar vence — a ordem no JSON e proposital

    // ("inter milan" antes de "milan")

    return vsSquads().find((r) => r.match && t.indexOf(String(r.match).toLowerCase()) !== -1) || null;

  }



  $$("[data-custom]").forEach((root) => {

    const inName = $("[data-custom-name]", root);

    const inNum = $("[data-custom-number]", root);

    const preview = $("[data-custom-preview]", root);

    const pvName = $("[data-preview-name]", root);

    const pvNum = $("[data-preview-num]", root);



    // Cor automatica da prensa: le a foto das costas e mede a luminosidade da

    // faixa onde o numero fica. Claro -> tinta escura; escuro -> branca (default).

    // Se o produto tiver cor fixa (data-ink-fixa, via metafield), nao mexe.

    var bgPrev = preview && preview.querySelector(".vs-custom__preview-bg");

    function ajustaTinta() {

      if (!preview || preview.dataset.inkSet || preview.hasAttribute("data-ink-fixa")) return;

      if (!bgPrev || !bgPrev.complete || !bgPrev.naturalWidth) return;

      try {

        var c = document.createElement("canvas"); c.width = 40; c.height = 40;

        var ctx = c.getContext("2d");

        ctx.drawImage(bgPrev, bgPrev.naturalWidth * 0.32, bgPrev.naturalHeight * 0.2,

                      bgPrev.naturalWidth * 0.36, bgPrev.naturalHeight * 0.3, 0, 0, 40, 40);

        var d = ctx.getImageData(0, 0, 40, 40).data, lum = 0, n = 0;

        for (var i = 0; i < d.length; i += 16) { lum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }

        lum /= n;

        if (lum > 150) { preview.style.setProperty("--kit-ink", "#14213d"); preview.classList.add("is-ink-dark"); }

        preview.dataset.inkSet = "1";

      } catch (e) { preview.dataset.inkSet = "1"; }   // CORS bloqueou -> fica branco

    }

    if (bgPrev) { bgPrev.complete ? ajustaTinta() : bgPrev.addEventListener("load", ajustaTinta); }



    function pintarPreview() {

      const n = (inName && inName.value || "").trim();

      const num = (inNum && inNum.value || "").trim();

      if (!preview) return;

      preview.hidden = !n && !num;

      if (pvName) {

        pvName.textContent = n;

        // Reducao GRADUAL por letra (pedido do Emerson): ate 5 letras tamanho

        // cheio; da 6a em diante, -5% por letra, com piso de 50%. Assim cada

        // letra a mais encolhe um pouco, sem degraus bruscos.

        // O base e lido UMA vez do CSS (cada estilo de kit tem o seu).

        if (!pvName.dataset.baseSize) pvName.dataset.baseSize = parseFloat(getComputedStyle(pvName).fontSize) || 15;

        var fator = n.length <= 5 ? 1 : Math.max(0.5, 1 - (n.length - 5) * 0.05);

        pvName.style.fontSize = (pvName.dataset.baseSize * fator) + "px";

      }

      if (pvNum) pvNum.textContent = num;

    }



    // so letras/espaco/hifen no nome, so digito no numero — o que a prensa aceita

    inName?.addEventListener("input", () => {

      inName.value = inName.value.toUpperCase().replace(/[^A-ZÀ-ÖØ-Þ .'-]/g, "");

      pintarPreview();

    });

    inNum?.addEventListener("input", () => {

      inNum.value = inNum.value.replace(/\D/g, "").slice(0, 2);

      pintarPreview();

    });



    // ---- abas ----

    const tabs = $("[data-custom-tabs]", root);

    $$("[data-custom-tab]", root).forEach((btn) => {

      btn.addEventListener("click", () => {

        const alvo = btn.dataset.customTab;

        $$("[data-custom-tab]", root).forEach((b) => b.classList.toggle("is-active", b === btn));

        $$("[data-custom-panel]", root).forEach((p) => p.classList.toggle("is-active", p.dataset.customPanel === alvo));

      });

    });



    // ---- elenco do time deste produto ----

    const squad = vsSquadDoProduto(root.dataset.productTitle);

    const select = $("[data-custom-player]", root);

    if (!squad || !select) return;                 // sem elenco: fica so a aba de digitar



    const linhas = String(squad.players || "").split("\n").map((l) => l.trim()).filter(Boolean);

    if (!linhas.length) return;



    linhas.forEach((linha) => {

      const corte = linha.lastIndexOf(",");

      if (corte < 0) return;

      const nome = linha.slice(0, corte).trim();

      const numero = linha.slice(corte + 1).trim();

      if (!nome || !numero) return;

      const opt = document.createElement("option");

      opt.value = nome + "|" + numero;

      opt.textContent = nome + " · " + numero;

      select.appendChild(opt);

    });



    const rotulo = $("[data-custom-team]", root);

    if (rotulo && squad.team) rotulo.textContent = squad.team + " squad";

    if (tabs) tabs.hidden = false;                 // so agora a aba faz sentido



    select.addEventListener("change", () => {

      if (!select.value) return;

      const [nome, numero] = select.value.split("|");

      if (inName) inName.value = nome;

      if (inNum) inNum.value = numero;

      pintarPreview();

    });

  });



  /* ---- Jersey patches (official patches as paid line items) -------------- */

  // FONTE DAS REGRAS: a secao "Configuração de Patches" (custom-patch-rules),

  // editavel pelo editor de temas. Cada regra traz keywords, excludeKeywords,

  // patchHandle e position (manga / peito / manga_peito). Ela publica tudo em

  // window.customPatchRules.

  // A tabela abaixo e so PLANO B, para o caso da secao nao estar no template.

  // Nao editar aqui: adicionar/alterar patch e no editor de temas.

  const VS_POS = { manga: "Sleeve", peito: "Chest", manga_peito: "Sleeve + Chest" };

  const VS_PATCH_FALLBACK = [

    { kw: ["arsenal","aston villa","bournemouth","brentford","brighton","burnley","chelsea","crystal palace","everton","fulham","leeds","liverpool","manchester","newcastle","nottingham","sunderland","tottenham","west ham","wolves"], handle: "patch-premier-league", where: "sleeve" },

    { kw: ["real madrid","barcelona","atletico","sevilla","betis","valencia","villarreal","sociedad","bilbao","getafe","osasuna","espanyol","celta","granada","mallorca","rayo","alaves","levante"], handle: "patch-laliga", where: "sleeve" },

    { kw: ["bayern","dortmund","leipzig","leverkusen","stuttgart","frankfurt","wolfsburg","gladbach","hoffenheim","freiburg","mainz","augsburg","bochum","köln","koln","union berlin","werder","heidenheim"], handle: "patch-bundesliga", where: "sleeve" },

    { kw: ["juventus","inter","milan","roma","lazio","napoli","atalanta","fiorentina","torino","bologna","verona","udinese","genoa","lecce","empoli","monza","cagliari","sassuolo"], handle: "patch-serie-a", where: "sleeve" },

    { kw: ["paris","marseille","lyon","monaco","lille","nice","rennes","nantes","strasbourg","montpellier","toulouse","reims","metz","brest","lens","lorient"], handle: "patch-ligue-1", where: "sleeve" },

    { kw: ["benfica","porto","sporting","braga"], handle: "patch-liga-portugal", where: "sleeve" },

    { kw: ["fluminense","vasco","corinthians","são paulo","sao paulo","santos","grêmio","gremio","internacional","cruzeiro","atlético mineiro","flamengo","palmeiras","bahia","fortaleza"], handle: "patch-brasileirao", where: "sleeve" },

    { kw: ["real madrid"], handle: "patch-champions-league-15", where: "sleeve" },

    { kw: ["barcelona"], handle: "patch-champions-league-5", where: "sleeve" },

    { kw: ["bayern"], handle: "patch-champions-league-6", where: "sleeve" },

    { kw: ["liverpool"], handle: "patch-champions-league-6", where: "sleeve" },

    { kw: ["milan"], exclude: ["inter milan"], handle: "patch-champions-league-7", where: "sleeve" },

    { kw: ["chelsea"], handle: "patch-world-champions", where: "chest" },

    { kw: ["paris"], handle: "patch-uefa-champions-25-26", where: "sleeve" },

    { kw: ["atletico madrid","borussia dortmund","bayer leverkusen","tottenham","atalanta","monaco","juventus","eintracht frankfurt"], handle: "patch-champions-league", where: "sleeve" },

    { kw: ["world cup","worldcup","copa do mundo"], handle: "patch-world-cup-2026", where: "sleeve" },

  ];

  // Normaliza as duas origens para o mesmo formato {kw, exclude, handle, pos}.

  function vsRegrasDePatch() {

    const doEditor = window.customPatchRules;

    if (Array.isArray(doEditor) && doEditor.length) {

      return doEditor.map((r) => ({

        kw: r.keywords || [],

        exclude: r.excludeKeywords || [],

        handle: r.patchHandle,

        pos: VS_POS[r.position] || "Sleeve",

      }));

    }

    return VS_PATCH_FALLBACK.map((r) => ({ kw: r.kw, exclude: r.exclude, handle: r.handle, pos: r.where === "chest" ? "Chest" : "Sleeve" }));

  }

  function vsMatchPatches(title) {

    const t = (title || "").toLowerCase();

    const out = [];

    vsRegrasDePatch().forEach((r) => {

      if (!r.handle) return;

      const hit = (r.kw || []).some((k) => t.includes(String(k).toLowerCase()));

      const ex = (r.exclude || []).some((k) => t.includes(String(k).toLowerCase()));

      if (hit && !ex && !out.some((o) => o.handle === r.handle)) out.push({ handle: r.handle, pos: r.pos });

    });

    return out;

  }

  function vsPatchLabel(title) {

    // So tira o prefixo "Patch"/"Patches" e mantem o resto do titulo intacto.

    // Antes trocava hifen por espaco e recapitalizava, o que quebrava temporada

    // ("24-25" -> "24 25") e deixava "Patches ..." virar "Es ...".

    return (title || "").replace(/^patch(es)?\b[\s-]*/i, "").trim();

  }

  // Patch so vai em CAMISA. Casaco, agasalho, calca, short, bone etc. nao levam

  // — nem quando o titulo tem a palavra "jersey" ("Spain Shorts ... Home Jersey").

  // Testado contra o catalogo inteiro: 109 produtos bloqueados, 0 camisa presa

  // por engano. Excecoes intencionais: "Cropped Jersey" e "Polo Edition Jersey"

  // sao camisas de jogo e continuam levando patch.

  const VS_NAO_CAMISA = /\b(track\s?top|track\s?suit|tracksuit|jacket|anthem|windbreaker|hoodie|sweatshirt|sweater|crewneck|puffer|coat|vest|jogger|pants|trousers|shorts|bermuda|socks|gloves|bag|backpack|cap|hat|beanie|scarf|key\s?chain|keychain|ball|boots|cleats|t[-\s]?shirt|tee|training\s?top|quarter\s?zip|half[-\s]?zip|slippers|sandals|towel|mug|poster)\b/i;

  const VS_TALVEZ_CAMISA = /\b(polo|cropped)\b/i;

  const VS_E_CAMISA = /\b(jersey|camisa|maillot|trikot|maglia)\b/i;

  function vsLevaPatch(titulo, tagsStr) {

    const t = titulo || "";

    const tags = (tagsStr || "").toLowerCase().split(",").map((x) => x.trim());

    if (tags.indexOf("tracksuits") !== -1) return false;

    if (VS_NAO_CAMISA.test(t)) return false;

    if (VS_TALVEZ_CAMISA.test(t) && !VS_E_CAMISA.test(t)) return false;

    return true;

  }



  // Gaveta "Make it yours": personalizacao (nome/numero + jogador) e patches no

  // MESMO lugar. A opcao de variante do +$5 e o bloco de campos sao MOVIDOS pra

  // dentro da gaveta — continuam dentro do <form>, entao a variante e as

  // properties do carrinho seguem funcionando sem nenhuma gambiarra.

  // Os patches continuam sendo produtos separados, adicionados via /cart/add.

  $$("[data-patches]").forEach(async (root) => {

    const gaveta = $("[data-patches-drawer]", root);

    const slot = $("[data-pz-slot]", root);

    const list = $("[data-patches-list]", root);

    if (!gaveta || !slot || !list) return;



    // 1) muda de lugar: opcao de personalizacao + campos vao pra gaveta

    const form = root.closest("[data-product-form]") || document;

    const optCustom = $("[data-opt-group][data-opt-custom]", form);

    const custom = $("[data-custom]", form);

    if (optCustom) slot.appendChild(optCustom);

    if (custom) slot.appendChild(custom);



    // 2) patches do produto (podem nao existir — a gaveta abre mesmo assim)

    const items = [];

    if (vsLevaPatch(root.dataset.productTitle, root.dataset.productTags)) {

      for (const r of vsMatchPatches(root.dataset.productTitle)) {

        try {

          const resp = await fetch("/products/" + r.handle + ".js");

          if (!resp.ok) continue;                     // regra aponta pra produto inexistente

          const p = await resp.json();

          const v = p.variants && p.variants[0];

          if (v) items.push({ id: v.id, price: v.price, title: p.title, pos: r.pos, img: p.featured_image || (p.images && p.images[0]) || "" });

        } catch (e) {}

      }

    }



    // Um patch por POSICAO: cada grupo e um conjunto de radios com um "None"

    // pra desmarcar. A prensa nao aceita dois patches no mesmo lugar.

    if (items.length) {

      const grupos = ["Sleeve", "Chest"].filter((pos) => items.some((it) => it.pos === pos));

      const uid = Math.random().toString(36).slice(2, 8);

      list.innerHTML = grupos.map((pos) => {

        const doGrupo = items.filter((it) => it.pos === pos);

        const nome = "vs-patch-" + pos.toLowerCase() + "-" + uid;

        return `

        <section class="vs-patchgrp">

          <h3 class="vs-patchgrp__ttl">${pos} patch <em>· pick one</em></h3>

          <div class="vs-patchgrp__list">

            ${doGrupo.map((it) => `

            <label class="vs-patch" data-patch-id="${it.id}" data-patch-name="${vsPatchLabel(it.title)}" data-patch-where="${it.pos}" data-patch-price="${it.price}">

              <input type="radio" name="${nome}" data-patch-check>

              <span class="vs-patch__box">${it.img ? `<img src="${it.img.replace(/(\.[a-z]+)(\?|$)/, "_100x$1$2")}" alt="" loading="lazy">` : ""}</span>

              <span class="vs-patch__info"><span class="vs-patch__name">${vsPatchLabel(it.title)}</span></span>

              <span class="vs-patch__price">+${money(it.price)}</span>

            </label>`).join("")}

            <label class="vs-patch vs-patch--none">

              <input type="radio" name="${nome}" data-patch-none checked>

              <span class="vs-patch__info"><span class="vs-patch__name">No ${pos.toLowerCase()} patch</span></span>

            </label>

          </div>

        </section>`;

      }).join("");

    }



    // 3) resumo: junta nome/numero e patches numa frase so

    const resumo = $("[data-patches-summary]", root);

    const total = $("[data-patches-total]", root);

    const trigger = $("[data-patches-open]", root);

    const inNome = custom ? $("[data-custom-name]", custom) : null;

    const inNum = custom ? $("[data-custom-number]", custom) : null;

    function atualizaResumo() {

      const partes = [];

      const temCustom = custom && !custom.hidden;

      const nome = (inNome && inNome.value || "").trim();

      const num = (inNum && inNum.value || "").trim();

      if (temCustom && (nome || num)) partes.push([nome, num].filter(Boolean).join(" "));

      else if (temCustom) partes.push("Name & number");

      $$("[data-patch-check]:checked", root).forEach((c) => {

        partes.push(c.closest(".vs-patch").dataset.patchName);

      });

      if (resumo) resumo.textContent = partes.length ? partes.join("  ·  ") : "Name, number and patches";

      if (total) total.textContent = partes.length

        ? partes.length + (partes.length === 1 ? " item added" : " items added")

        : "Nothing added";

      if (trigger) trigger.classList.toggle("has-sel", partes.length > 0);

    }

    $$("[data-patch-check],[data-patch-none]", root).forEach((i) => i.addEventListener("change", atualizaResumo));

    $$("[data-opt-value]", root).forEach((b) => b.addEventListener("click", () => setTimeout(atualizaResumo, 0)));

    [inNome, inNum].forEach((i) => i && i.addEventListener("input", atualizaResumo));

    atualizaResumo();



    // 4) gaveta lateral — mesmo gesto do size chart

    const abre = () => { gaveta.hidden = false; requestAnimationFrame(() => gaveta.classList.add("is-open")); document.body.style.overflow = "hidden"; };

    const fecha = () => { gaveta.classList.remove("is-open"); document.body.style.overflow = ""; setTimeout(() => { gaveta.hidden = true; }, 260); atualizaResumo(); };

    trigger?.addEventListener("click", abre);

    $$("[data-patches-close]", root).forEach((b) => b.addEventListener("click", fecha));

    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !gaveta.hidden) fecha(); });



    // abre se houver patch OU personalizacao — antes so aparecia com patch

    if (items.length || optCustom || custom) root.hidden = false;

  });



  /* ---- Filter & Sort drawer (PLP) ---------------------------------------- */

  const fDrawer = $("[data-filter-drawer]");

  const fOverlay = $("[data-filter-overlay]");

  function openF() { fDrawer?.classList.add("is-open"); fOverlay?.classList.add("is-open"); document.body.style.overflow = "hidden"; }

  function closeF() { fDrawer?.classList.remove("is-open"); fOverlay?.classList.remove("is-open"); document.body.style.overflow = ""; }

  $$("[data-filter-open]").forEach((b) => b.addEventListener("click", openF));

  $$("[data-filter-close]").forEach((b) => b.addEventListener("click", closeF));

  fOverlay?.addEventListener("click", closeF);



  /* ---- Collection description show more ----------------------------------- */

  $$("[data-desc-toggle]").forEach((btn) => btn.addEventListener("click", () => {

    const d = btn.closest("[data-desc]");

    const on = d.classList.toggle("is-open");

    btn.textContent = on ? "Show less" : "Show more";

  }));



  /* ---- Ships-by date (today + 2 calendar days) --------------------------- */

  $$("[data-shipby]").forEach((el) => {

    const d = new Date();

    d.setDate(d.getDate() + 2);

    el.textContent = d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

  });



  /* ---- PDP gallery (Nike-style: thumbs + stage + arrows + swipe) --------- */

  $$("[data-gallery]").forEach((g) => {

    const imgs = $$(".vs-gallery__img", g);

    const thumbs = $$(".vs-gallery__thumb", g);

    if (imgs.length < 2) return;

    let idx = 0;

    const show = (i) => {

      idx = (i + imgs.length) % imgs.length;

      imgs.forEach((im, j) => im.classList.toggle("is-active", j === idx));

      thumbs.forEach((t, j) => t.classList.toggle("is-active", j === idx));

      const at = thumbs[idx];

      if (at) at.scrollIntoView({ block: "nearest", inline: "nearest" });

    };

    thumbs.forEach((t, j) => t.addEventListener("click", () => show(j)));

    $("[data-gprev]", g)?.addEventListener("click", () => show(idx - 1));

    $("[data-gnext]", g)?.addEventListener("click", () => show(idx + 1));

    const stage = $(".vs-gallery__stage", g);

    let sx = null;

    stage?.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; }, { passive: true });

    stage?.addEventListener("touchend", (e) => {

      if (sx === null) return;

      const dx = e.changedTouches[0].clientX - sx;

      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);

      sx = null;

    }, { passive: true });

  });



  /* ---- Brand strip: seamless marquee on mobile --------------------------- */

  // NAO duplicar aqui. Isto e de quando o Liquid renderizava a lista uma vez so;

  // hoje o vs-brand-strip.liquid ja renderiza DUAS copias, que e o que faz o

  // translateX(-50%) fechar sem salto. Duplicar de novo dava quatro copias e,

  // pior, o `innerHTML +=` reconstruia todos os <img>: eles voltavam vazios e so

  // recarregavam ao entrar na tela — os logos "sumiam" a cada volta da esteira.

  // A largura da faixa dobrando no meio da animacao ainda mudava o que -50%

  // significa, dando o solavanco. (2026-08-22)



  /* ---- Announcement slideshow (fade rotator + arrows) -------------------- */

  $$("[data-ann]").forEach((bar) => {

    const msgs = $$(".vs-ann__msg", bar);

    if (msgs.length < 2) return;

    let i = 0, timer;

    /* aria-hidden acompanha o is-active: sem isso o leitor de tela anuncia as

       SEIS mensagens de uma vez em toda pagina (opacity:0 nao esconde do a11y) */

    const show = (n) => {

      i = (n + msgs.length) % msgs.length;

      msgs.forEach((m, x) => {

        const on = x === i;

        m.classList.toggle("is-active", on);

        if (on) m.removeAttribute("aria-hidden"); else m.setAttribute("aria-hidden", "true");

      });

    };

    show(i);

    const start = () => { timer = setInterval(() => show(i + 1), 5000); };

    const stop = () => clearInterval(timer);

    $(".vs-ann__prev", bar)?.addEventListener("click", () => { show(i - 1); stop(); start(); });

    $(".vs-ann__next", bar)?.addEventListener("click", () => { show(i + 1); stop(); start(); });

    bar.addEventListener("mouseenter", stop);

    bar.addEventListener("mouseleave", start);

    start();

  });



  /* ---- Init cart count on load ------------------------------------------- */

  getCart().then(pintaContagem).catch(() => {});



  /* ---- Carrossel auto-rotativo em loop -----------------------------------

     Duplica os itens uma vez para o loop ser continuo (sem "voltar" visivel).

     Pausa quando o usuario toca, arrasta, passa o mouse ou usa o teclado;

     volta sozinho pouco depois. Respeita prefers-reduced-motion.          */

  $$("[data-autoscroll]").forEach((track) => {

    const reduz = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduz) return;

    const originais = Array.from(track.children);

    if (originais.length < 2) return;

    // clona para o loop ficar continuo

    originais.forEach((el) => {

      const c = el.cloneNode(true);

      c.setAttribute("aria-hidden", "true");

      c.tabIndex = -1;

      track.appendChild(c);

    });

    const vel = parseFloat(track.dataset.autoscrollSpeed || "0.22");

    let pausado = false, parado = false, retomar = null, raf = null;

    const metade = () => track.scrollWidth / 2;

    const pausa = () => { pausado = true; clearTimeout(retomar); };

    const volta = (ms) => { if (parado) return; clearTimeout(retomar); retomar = setTimeout(() => { pausado = false; }, ms); };

    // Tocar/arrastar/clicar entrega o controle ao cliente: para de vez ate recarregar.

    const pararDeVez = () => { parado = true; clearTimeout(retomar); track.style.scrollSnapType = "x proximity"; };

    // dedo / mouse / teclado

    track.addEventListener("touchstart", pararDeVez, { passive: true });

    

    track.addEventListener("pointerdown", pararDeVez);

    

    track.addEventListener("mouseenter", pausa);

    track.addEventListener("mouseleave", () => volta(400));

    track.addEventListener("wheel", pararDeVez, { passive: true });

    track.addEventListener("focusin", pausa);

    track.addEventListener("focusout", () => volta(1200));

    const passo = () => {

      if (parado) { raf = null; return; }

      if (!pausado) {

        track.scrollLeft += vel;

        if (track.scrollLeft >= metade()) track.scrollLeft -= metade();

      }

      raf = requestAnimationFrame(passo);

    };

    // so anima quando visivel na tela

    if ("IntersectionObserver" in window) {

      new IntersectionObserver((ents) => ents.forEach((en) => {

        if (en.isIntersecting) { if (!raf && !parado) raf = requestAnimationFrame(passo); }

        else if (raf) { cancelAnimationFrame(raf); raf = null; }

      }), { threshold: 0.15 }).observe(track);

    } else {

      raf = requestAnimationFrame(passo);

    }

  });





  /* ---- Marquee CSS -> arrastavel ao toque -------------------------------

     As faixas rotativas usam animacao CSS (transform), que nao permite

     arrastar. Ao primeiro toque/clique: congela onde esta, converte a

     posicao para scroll nativo e desliga a animacao de vez. A partir dai o

     cliente navega com o dedo. Volta a girar so recarregando a pagina.    */

  $$('[class*="marquee"] [class*="track"]').forEach((track) => {

    const box = track.parentElement;

    if (!box || track.dataset.marqueeGrab) return;

    track.dataset.marqueeGrab = "1";



    const assumir = () => {

      if (track.dataset.solto) return;

      track.dataset.solto = "1";

      // posicao atual da animacao -> deslocamento em px

      const m = new DOMMatrixReadOnly(getComputedStyle(track).transform);

      const desloc = Math.abs(m.m41 || 0);

      track.style.animation = "none";

      track.style.transform = "none";

      box.style.overflowX = "auto";

      box.style.scrollSnapType = "x proximity";

      box.style.webkitOverflowScrolling = "touch";

      box.style.scrollbarWidth = "none";

      box.scrollLeft = desloc;

    };



    box.addEventListener("touchstart", assumir, { passive: true });

    box.addEventListener("pointerdown", assumir);

    box.addEventListener("wheel", assumir, { passive: true });

  });





})();



  /* ---- Size guide (painel lateral) --------------------------------------- */

  (function () {

    const panel = document.querySelector("[data-sizechart]");

    if (!panel) return;

    const open = () => { panel.hidden = false; document.body.classList.add("vs-sizepanel-open"); };

    const close = () => { panel.hidden = true; document.body.classList.remove("vs-sizepanel-open"); };

    document.querySelectorAll("[data-sizechart-open]").forEach((b) => b.addEventListener("click", open));

    panel.querySelectorAll("[data-sizechart-close]").forEach((b) => b.addEventListener("click", close));

    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.hidden) close(); });

  







})();

/* ---- Bolsa lateral ------------------------------------------------------
   Estado no <html> porque o HTML da gaveta e trocado inteiro a cada mudanca
   do carrinho — guardar estado dentro dela se perderia no meio da interacao.
   Os cliques sao delegados no document pelo mesmo motivo.                */
(function () {
  const raiz = document.documentElement;
  const temGaveta = () => !!document.getElementById("vsCart");
  let ocupado = false;

  function abrir() { if (temGaveta()) raiz.classList.add("vsd-open"); }
  function fechar() { raiz.classList.remove("vsd-open"); }

  // busca a section ja renderizada: preco, moeda e promocao vem prontos do Liquid
  async function atualiza() {
    const alvo = document.getElementById("shopify-section-vs-cart-drawer");
    if (!alvo) return;
    const r = await fetch("/?sections=vs-cart-drawer", { headers: { Accept: "application/json" } });
    const j = await r.json();
    const html = j["vs-cart-drawer"];
    if (typeof html !== "string") return;
    const doc = new DOMParser().parseFromString(html, "text/html");

    const novo = doc.getElementById("shopify-section-vs-cart-drawer");

    // O checkout rapido (Shop Pay e afins) so vem no carregamento normal da

    // pagina: a Section Rendering API nao devolve

    // content_for_additional_checkout_buttons. Entao eu tiro o bloco vivo

    // antes de trocar o HTML e recoloco depois — movendo o no, nunca clonando,

    // porque o botao do Shop Pay e um iframe com sessao propria.

    const rapido = alvo.querySelector(".vsd__rapido");

    const guardado = rapido && rapido.children.length ? rapido : null;

    if (guardado) guardado.remove();

    alvo.innerHTML = novo ? novo.innerHTML : html;

    const vazio = alvo.querySelector(".vsd__rapido");

    if (guardado) { if (vazio) vazio.replaceWith(guardado); else { const f = alvo.querySelector("form[action]"); if (f) f.appendChild(guardado); } }
    naTela.clear();

    autoProtege();

    // contador do header: sem parche e sem a protecao (requires_shipping false)
    fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json()).then((c) => {
      const n = (c.items || []).reduce((s, it) =>

        s + ((it.properties && it.properties._for) || it.requires_shipping === false ? 0 : it.quantity), 0);

      document.querySelectorAll(".vs-cart-count").forEach((el) => { el.textContent = n; el.hidden = n === 0; });

      // sem camiseta nenhuma, a protecao de envio nao pode ficar sozinha:

      // seria cobrar entrega de uma entrega que nao existe mais

      if (n === 0) {

        const orfa = (c.items || []).find((it) => it.requires_shipping === false);

        if (orfa) fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },

          body: JSON.stringify({ id: orfa.key, quantity: 0 }) }).then(() => atualiza());

      }
    }).catch(() => {});
  }

  // A protecao ja vem marcada. Como e um item PAGO entrando sem a pessoa

  // pedir, so entra com camiseta na bolsa, e desmarcar fica gravado: se ela

  // tirou uma vez, eu nao ponho de novo — senao o cartao viraria armadilha.

  const RECUSOU = "vs-prot-off";

  function recusou() { try { return localStorage.getItem(RECUSOU) === "1"; } catch (e) { return false; } }

  function marcaRecusa(v) { try { v ? localStorage.setItem(RECUSOU, "1") : localStorage.removeItem(RECUSOU); } catch (e) {} }



  let autoEmCurso = false;

  async function autoProtege() {

    if (autoEmCurso || recusou()) return;

    const cx = document.querySelector("[data-prot]");

    if (!cx || cx.checked) return;

    const linhas = document.querySelectorAll("#vsCart .vsd__line");

    if (!linhas.length) return;                 // nunca sozinha na bolsa

    autoEmCurso = true;

    try {

      await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },

        body: JSON.stringify({ items: [{ id: Number(cx.dataset.var), quantity: 1 }] }) });

      await atualiza();

    } catch (e) {} finally { autoEmCurso = false; }

  }



  // A mesma camiseta pode estar espalhada em varias linhas (parte paga +

  // parte de cortesia do desconto). As chaves dessas linhas MUDAM a cada

  // alteracao, entao nao da pra guardar uma lista e sair removendo: a

  // segunda chamada iria com chave velha. Removo em laco, sempre relendo o

  // carrinho e usando a chave que existe agora.

  function assinatura(it) {

    let s = it.variant_id + "|";

    const p = it.properties || {};

    for (const nome of Object.keys(p)) s += nome + "=" + p[nome] + ";";

    return s;

  }

  async function tiraGrupo(sig) {

    for (let volta = 0; volta < 8; volta++) {           // teto: nunca gira sozinho

      const c = await (await fetch("/cart.js", { headers: { Accept: "application/json" } })).json();

      const alvo = (c.items || []).find((it) => assinatura(it) === sig);

      if (!alvo) return;

      const r = await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },

        body: JSON.stringify({ id: alvo.key, quantity: 0 }) });

      if (!r.ok) return;

    }

  }



  // Fila com fusao: cliques rapidos no +/- nao se perdem nem viram tres

  // idas ao servidor. Guardo a quantidade final por linha e mando so ela.

  let fila = Promise.resolve();

  const pendente = new Map();

  const naTela = new Map();  // chave da linha paga -> total do grupo que a pessoa esta vendo



  function muda(id, quantity) {

    pendente.set(id, quantity);

    fila = fila.then(async () => {

      if (!pendente.has(id)) return;              // ja foi junto com outro clique

      const q = pendente.get(id);

      pendente.delete(id);

      // q e a quantidade da LINHA PAGA, nao o total do grupo: quem decide

      // quantas ficam gratis é o desconto, e ele recalcula sozinho.

      await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id, quantity: q }) });

      await atualiza();

    }).catch(() => {});

    return fila;

  }

  // o icone da sacola abre a gaveta em vez de ir pra /cart.
  // Ctrl/cmd/meio continuam abrindo a pagina, que e o que quem faz isso espera.
  document.addEventListener("click", (e) => {
    const icone = e.target.closest('[data-bolsa]');
    if (icone && !e.metaKey && !e.ctrlKey && e.button === 0) {
      e.preventDefault(); abrir(); atualiza(); return;
    }
    if (e.target.closest("[data-drawer-close]")) { fechar(); return; }

    const linha = e.target.closest(".vsd__line, .vsd__sub");

    if (!linha) return;

    const chave = linha.dataset.key;
    if (e.target.closest("[data-rm]")) {

      const sig = linha.dataset.sig;

      linha.remove();                                   // some da tela na hora

      fila = fila.then(async () => {

        if (sig) await tiraGrupo(sig);

        else await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: chave, quantity: 0 }) });

        await atualiza();

      }).catch(() => {});

      return;

    }
    const q = e.target.closest("[data-qty]");

    if (q) {

      const campo = linha.querySelector("[data-qtyval]");

      const total = Number(linha.dataset.total) || Number(campo && campo.textContent) || 1;

      const paga = Number(linha.dataset.paga) || total;

      // parto da fila, nao da tela: dois cliques seguidos leriam o mesmo numero velho

      const base = naTela.has(chave) ? naTela.get(chave) : total;

      const alvo = q.dataset.qty === "inc" ? base + 1 : Math.max(0, base - 1);

      naTela.set(chave, alvo);

      if (campo && alvo > 0) campo.textContent = alvo;   // resposta imediata

      muda(chave, Math.max(0, paga + (alvo - total)));   // mando o delta na linha paga

    }
  });

  // protecao de envio: e um produto, entao ligar/desligar e add/remove
  document.addEventListener("change", async (e) => {
    const cx = e.target.closest("[data-prot]");
    if (!cx || ocupado) return;
    ocupado = true;
    cx.closest(".vsd__prot").classList.toggle("is-on", cx.checked);

    marcaRecusa(!cx.checked);
    try {
      if (cx.checked) {
        await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(cx.dataset.var), quantity: 1 }] }) });
      } else if (cx.dataset.key) {
        await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: cx.dataset.key, quantity: 0 }) });
      }
      await atualiza();
    } finally { ocupado = false; }
  });

  document.addEventListener("keydown", (e) => { if (e.key === "Escape") fechar(); });
  document.addEventListener("vs:added", () => { atualiza().then(abrir); });
})();


/* purga shipping-protection do carrinho (oferta descontinuada 2026-09-11) */
(function(){
  try{
    fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json();}).then(function(c){
      if(!c||!c.items) return;
      var prot=null;
      for(var i=0;i<c.items.length;i++){ if(c.items[i].handle==="shipping-protection"){ prot=c.items[i]; break; } }
      if(!prot) return;
      fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:prot.key,quantity:0})}).catch(function(){});
    }).catch(function(){});
  }catch(e){}
})();
